import { v4 } from "uuid"

export class Commitments {
    id: string = v4();
    name: string = '';
    reCorder: number = 0;
    percentage?:number=0;
}